import { render, staticRenderFns } from "./change-drawer.vue?vue&type=template&id=01512c7f&"
import script from "./change-drawer.vue?vue&type=script&lang=js&"
export * from "./change-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports